import { Box, FormControl } from "@mui/material";
import { useContext, useState } from "react";
import { getUrl, uploadToFbStorage } from "../../lib/global";
import { useRouter } from "next/router";
import { LoadingButton } from "@mui/lab";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db, functions } from "../../../api_config/firebase-configuration";
import { httpsCallable } from "firebase/functions";
import { FileUpload, ImageFileUpload } from "../ImageFileUpload";

import { dcContent } from "../../../services/content";
import { useForm } from "react-hook-form";
import allEquipment from "../../../services/content/allEquipment";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
import { DbProvider } from "../../../services/db/DbProvider";
import { useUserData } from "../../hooks/useUserData";
import { LocalizationContext } from "../../lib/context";
import theme from "../../styles/theme";
import InputCover from "../InputCover";
import UpdatableInput from "../UpdatableInput";

import LoadingMuiButton from "../LoadingMuiButton";
import { MuiInput } from "../MuiInput";
import HaveQuestions from "../HaveQuestions";
const dbProvider = new DbProvider();

const hideEmail = (email) => {
  if (!email) return "";
  let hiddenEmail = "";
  const splittedEmail = email?.split("@")[0];
  for (let i = 0; i < splittedEmail.length; i++) {
    if (i > 0 && i < splittedEmail.length - 1) {
      hiddenEmail += "*";
    } else {
      hiddenEmail += email[i];
    }
  }
  return `${hiddenEmail}@${email.split("@")[1]}`;
};

export function RegisterDetails({ existing, user, userData }) {
  // const perfTr = trace(perf, "REGISTER_DETAILS");
  // perfTr.start();

  const router = useRouter();
  const { actDroner } = useUserData();
  const {
    registerDetailsForm,
    profilePage,
    settingsPage,
    uiGeneral,
    errorPage,
  } = useContext(LocalizationContext).localeStrings;
  const formFields = registerDetailsForm.formFields;
  const getFormField = (fieldId) =>
    formFields.filter((o) => o.fieldId === fieldId)[0];

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    ...userData,
    uid: user?.uid,
  });

  const [updatedText, setUpdatedText] = useState(() => "");
  const [textChanged, setTextChanged] = useState(() => false);
  const [loading, setLoading] = useState(false);
  const [profImage, setProfImage] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [userCertificate, setUserCertificate] = useState(null);
  const [imageUploaded, setImageUploaded] = useState(() => false);
  const [certificateUploaded, setCertificateUploaded] = useState(() => false);
  const [openInputs, setOpenInputs] = useState({
    displayName: false,
    country: false,
    username: false,
    tel: false,
    contactEmail: false,
    freeTravelDist: false,
    maxTravelDist: false,
    skills: false,
    equipment: false,
    bio: false,
    certificate: false,
  });

  // HELPER FUNCTIONS FOR UPDATING OPENINPUTS STATE
  const updateState = (key) => {
    const openInputsObj = openInputs;
    Object.keys(openInputsObj).forEach((item) =>
      key !== item
        ? (openInputsObj[item] = false)
        : (openInputsObj[item] = true)
    );
    return openInputsObj;
  };
  const makeAllFalse = () => {
    const openInputsObj = openInputs;
    Object.keys(openInputsObj).forEach((item) => (openInputsObj[item] = false));
    return openInputsObj;
  };

  const onClickHandler = (str) => {
    setUpdatedText("");
    setTextChanged(false);
    if (openInputs[str] === true) return setOpenInputs({ ...makeAllFalse() });
    setOpenInputs({ ...updateState(str) });
  };
  const onSubmitHandler = (obj) => {
    textChanged ? handleFormSubmit(obj) : setOpenInputs({ ...makeAllFalse() });
  };
  const onChangeHandler = (text) => {
    setUpdatedText(text);
    setTextChanged(true);
  };

  let allowedSkills = 6;

  try {
    if (!!actDroner?.subscriptionLevel)
      allowedSkills = dcContent.pricingLimits.filter(
        (o) => o.priceName === actDroner.subscriptionLevel
      )[0].maxSkills;
  } catch (e) {
    // console.log("allowed skill error: ", e);
  }

  const welcomeFn = httpsCallable(functions, "sendgrid-welcomeEmail");

  // UPDATE USER DATA
  async function handleFormSubmit(updatedObject) {
    console.log("updatedObject:", updatedObject);
    setTextChanged(false);

    const data = {
      ...userData,
      uid: user?.uid,
      ...updatedObject,
    };

    delete data.userCreated;
    if (parseInt(data.freeDist) > parseInt(data.maxRange)) {
      return alert(dcContent.errors.freeDistMaxRange);
    }
    data.username = data.username.replace(/\s\s+/g, " ").trim();
    if (allowedSkills >= 0 && data.skills?.length > allowedSkills) {
      return alert("max skills: " + allowedSkills);
    }
    if (data.equipment === undefined) {
      data.equipment = [];
    }
    const address = data.location ? data.location.label : "";
    let coors;
    let countryObject;
    let countryISOCode;
    try {
      const results = await geocodeByAddress(address);
      countryObject = results[0].address_components
        .filter((c) => c.types.includes("country"))
        .map((a) => ({ long_name: a.long_name, short_name: a.short_name }))[0];
      countryISOCode = countryObject.short_name;
      coors = await getLatLng(results[0]);
    } catch (e) {
      console.error(e);
    }
    setLoading(true);

    // Checking if username is taken or not
    try {
      const existingUsernames = [];
      const querySnapshot = await getDocs(
        query(collection(db, "usernames"), where("userId", "!=", data.uid))
      );
      querySnapshot.forEach((doc) => {
        existingUsernames.push(doc.id.toLowerCase());
      });
      // console.log("existingUsernames:", existingUsernames);
      if (existingUsernames.includes(data.username.toLowerCase())) {
        setLoading(false);
        setOpenInputs({ ...makeAllFalse() });
        return alert(dcContent.errors.usernameTaken);
      }
    } catch (e) {
      // console.log("fb error: ", e);
      setLoading(false);
      setOpenInputs({ ...makeAllFalse() });
    }

    // I think here the username is deleted first
    if (existing) {
      try {
        await deleteDoc(doc(db, "usernames", userData.username));
      } catch (e) {
        // console.log("fb error1: ", e);
        setLoading(false);
        setOpenInputs({ ...makeAllFalse() });
      }
    }
    // Here new username is created
    try {
      await setDoc(doc(db, "usernames", data.username), {
        userId: user.uid,
      });
    } catch (e) {
      // console.log("fb error2: ", e);
      setLoading(false);
      setOpenInputs({ ...makeAllFalse() });
    }

    let dataForUsersUpdate;
    try {
      dataForUsersUpdate = {
        ...data,
        countryObject: countryObject ?? {},
        countryISOCode: countryISOCode ?? "",
        address: address,
        lat: coors?.lat ? coors.lat : "",
        lng: coors?.lng ? coors.lng : "",
        deleted: false,
        subscriptionLevel: "free",
      };
    } catch (e) {
      setLoading(false);
      setOpenInputs({ ...makeAllFalse() });
      return alert(e.toString());
    }
    if (existing) {
      dataForUsersUpdate = {
        ...dataForUsersUpdate,
        subscriptionLevel: actDroner?.subscriptionLevel,
      };
    }
    try {
      await updateDoc(doc(db, "users", user.uid), dataForUsersUpdate);
    } catch (e) {
      // console.log("fb error4: ", e);
      setLoading(false);
      setOpenInputs({ ...makeAllFalse() });
    }
    const { meta, tax_exempt, tax_ids, uid, ...publicData } = data;
    let dataForUsersPublicUpdate;
    try {
      dataForUsersPublicUpdate = {
        ...publicData,
        countryObject: countryObject ?? {},
        countryISOCode: countryISOCode ?? "",
        address: address,
        lat: coors?.lat ? coors.lat : "",
        lng: coors?.lng ? coors.lng : "",
        deleted: false,
      };
    } catch (e) {
      return alert(e.toString());
    }
    if (existing) {
      dataForUsersPublicUpdate = {
        ...dataForUsersPublicUpdate,
        subscriptionLevel: actDroner?.subscriptionLevel,
      };
    }
    try {
      await setDoc(doc(db, "usersPublic", user.uid), dataForUsersPublicUpdate, {
        merge: true,
      });
    } catch (e) {
      // console.log("fb error5: ", e);
      setLoading(false);
      setOpenInputs({ ...makeAllFalse() });
    }

    // UPDATING PROFILE IMAGE
    try {
      if (profImage !== userData.profImage) {
        const url = await uploadToFbStorage(
          profImage,
          `profImages/${user.uid}`
        );
        await updateDoc(doc(db, "users", user.uid), {
          profImage: url ?? null,
        });
        await dbProvider.addDocWithId(
          {
            profImage: profImage ? url : null,
          },
          "usersPublic",
          user.uid,
          { merge: true }
        );
        setImageUploaded(false);
      }
    } catch (e) {
      // console.log("fb error6: ", e);
      setLoading(false);
      setOpenInputs({ ...makeAllFalse() });
      setImageUploaded(false);
    }

    // UPDATING COVER IMAGE
    try {
      if (coverImage !== userData.coverImage) {
        const url = await uploadToFbStorage(
          coverImage,
          `coverImages/${user.uid}`
        );
        await updateDoc(doc(db, "users", user.uid), {
          coverImage: coverImage ? url : null,
        });
        await setDoc(
          doc(db, "usersPublic", user.uid),
          {
            coverImage: coverImage ? url : null,
          },
          { merge: true }
        );
        setImageUploaded(false);
      }
    } catch (e) {
      // console.log("fb error7: ", e);
      setLoading(false);
      setImageUploaded(false);
      setOpenInputs({ ...makeAllFalse() });
    }

    try {
      if (userCertificate !== userData.userCertificate) {
        const url = await uploadToFbStorage(
          userCertificate,
          `certificatesFiles/${user.uid}`
        );
        await updateDoc(doc(db, "users", user.uid), {
          userCertificate: url ?? null,
        });
        await dbProvider.addDocWithId(
          {
            userCertificate: userCertificate ? url : null,
          },
          "userCertificate",
          user.uid,
          { merge: true }
        );
        setCertificateUploaded(false);
      }
    } catch (e) {
      setLoading(false);
      setOpenInputs({ ...makeAllFalse() });
      setCertificateUploaded(false);
    }

    setLoading(false);
    if (existing) {
      setOpenInputs({ ...makeAllFalse() });
      await router.push("/droners/" + data.username);
    }
    if (!existing) {
      // router.push("/pricing");
      try {
        await welcomeFn({
          email: user.email,
          username: data.username,
        });
      } catch (e) {
        console.error(e);
      }
    }
  }

  // perfTr.stop();

  // this function finds the validation criterias for the inputs
  const findInputStrings = (fieldId) => {
    const fieldsFromDcCont = dcContent.forms.registerDetails.find(
      (s) => s.id === fieldId
    );
    const formFieldsItem = formFields.find((item) => item.fieldId === fieldId);
    return {
      ...formFieldsItem,
      ...fieldsFromDcCont,
    };
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          mx: "auto",
          flexDirection: "column",
          width: "100%",
          gap: 2,
        }}
      >
        {existing && (
          <h2 className="settings__primaryText">
            {
              settingsPage.settingsItems.filter(
                (i) => i.blockId === "public"
              )[0].header
            }
          </h2>
        )}

        {/* UPLOAD IMAGES */}
        <Box
          sx={{
            display: "grid",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              gap: { xs: "20px", sm: "32px" },
            }}
            className="uploadImagesBox"
          >
            <Box sx={{ gridRow: "1", gridColumn: "span 1" }}>
              <ImageFileUpload
                image={getUrl(profImage)}
                setImage={setProfImage}
                initial={userData?.profImage}
                title={profilePage.addProfileImage}
                imgLimit="Max. 50 kb 150x150px"
                onChange={setImageUploaded}
              />
            </Box>
            <Box sx={{ gridRow: "1", gridColumn: "span 2" }}>
              <ImageFileUpload
                image={getUrl(coverImage)}
                setImage={setCoverImage}
                initial={userData?.coverImage}
                title={profilePage.addBannerButton}
                imgLimit="Max. 1 Mb 600x800px"
                onChange={setImageUploaded}
              />
            </Box>
          </Box>

          {imageUploaded && existing && (
            <FormControl
              sx={{
                mt: 3,
                width: "100%",
                maxWidth: 600,
                display: "grid",
                justifyContent: "center",
              }}
              component="form"
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              <LoadingMuiButton
                loading={loading}
                text={uiGeneral?.saveButton}
              />
            </FormControl>
          )}
        </Box>

        {/* REGISTER DETAILS */}
        {!existing && (
          <div
            style={{
              margin: "16px auto 0",
              width: "100%",
              maxWidth: "600px",
              display: "grid",
            }}
          >
            <FormControl
              sx={{ gap: 2, width: "100%", margin: "0 auto" }}
              component="form"
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              <MuiInput
                label={getFormField("displayName").label}
                inputStrings={findInputStrings("displayName")}
                errors={errors}
                register={register}
                onChange={() => {}}
              />
              <MuiInput
                label={
                  registerDetailsForm.formFields.filter(
                    (i) => i.fieldId === "username"
                  )[0].label
                }
                inputStrings={findInputStrings("username")}
                errors={errors}
                register={register}
                onChange={() => {}}
              />
              <MuiInput
                label={uiGeneral.country}
                inputStrings={findInputStrings("location")}
                errors={errors}
                register={register}
                onChange={() => {}}
                type="location"
                control={control}
              />

              {/* <MuiInput
                label="City/Town"
                inputStrings={findInputStrings("location")}
                errors={errors}
                register={register}
                onChange={() => {}}
                type="location"
                control={control}
              /> */}

              <MuiInput
                label={
                  registerDetailsForm.formFields.filter(
                    (i) => i.fieldId === "contactEmail"
                  )[0].label
                }
                inputStrings={findInputStrings("contactEmail")}
                errors={errors}
                register={register}
                onChange={() => {}}
              />

              {/* <div className="certification-input">
                <MuiInput
                  label="Certification"
                  inputStrings={findInputStrings("displayName")}
                  errors={errors}
                  register={register}
                  onChange={() => {}}
                />
                <FileUpload
                  image={getUrl(profImage)}
                  setImage={setProfImage}
                  initial={userData?.profImage}
                  title="Add profile picture"
                  imgLimit="Max. 50 kb 150x150px"
                  onSubmit={handleFormSubmit}
                  type="certification"
                />
              </div> */}

              <MuiInput
                label={profilePage.freeTravelDistanceRow}
                inputStrings={findInputStrings("freeDist")}
                errors={errors}
                register={register}
                onChange={() => {}}
              />

              <MuiInput
                label={profilePage.maxTravelRangeRow}
                inputStrings={findInputStrings("maxRange")}
                errors={errors}
                register={register}
                onChange={() => {}}
              />

              <MuiInput
                label={
                  registerDetailsForm.formFields.filter(
                    (f) => f.fieldId === "skills"
                  )[0].label
                }
                inputStrings={findInputStrings("skills")}
                errors={errors}
                register={register}
                onChange={() => {}}
                existing={existing}
                actDroner={actDroner}
                control={control}
                type="skills"
              />

              <MuiInput
                label={profilePage.equipmentRow}
                inputStrings={findInputStrings("equipment")}
                errors={errors}
                register={register}
                onChange={() => {}}
                type="equipment"
                allEquipment={allEquipment}
                control={control}
              />

              <MuiInput
                label={profilePage.aboutMeRow}
                inputStrings={findInputStrings("bio")}
                errors={errors}
                register={register}
                onChange={() => {}}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  marginTop: { sx: 4, xs: 1 },
                }}
              >
                <LoadingButton
                  variant="contained"
                  sx={{
                    backgroundColor: theme.palette.primary.light,
                    width: "189px",
                  }}
                  loading={loading}
                  type="submit"
                >
                  {uiGeneral?.saveButton} and continue
                </LoadingButton>
              </Box>
            </FormControl>

            <Box sx={{ marginTop: { sx: "32px", xs: "26px" } }}>
              <HaveQuestions email={errorPage?.mailToLink} />
            </Box>
          </div>
        )}

        {/* UPDATING PUBLIC INFO */}
        {existing && (
          <div
            style={{
              margin: "16px auto 0",
              width: "100%",
              maxWidth: "600px",
              display: "grid",
              rowGap: "26px",
            }}
          >
            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("displayName").label}
              value={userData.displayName}
              onClick={() => onClickHandler("displayName")}
            />
            {openInputs.displayName && (
              <UpdatableInput
                defaultValue={userData.displayName}
                onChange={(text) => onChangeHandler(text)}
                onSubmit={() => onSubmitHandler({ displayName: updatedText })}
                loading={loading}
                inputStrings={findInputStrings("displayName")}
                type="textField"
                user={user}
                userData={userData}
              />
            )}

            <InputCover
              label={getFormField("location").label}
              value={userData?.countryObject?.long_name}
              onClick={() => onClickHandler("country")}
            />
            {openInputs.country && (
              <UpdatableInput
                loading={loading}
                inputStrings={findInputStrings("location")}
                onSubmit={handleFormSubmit}
                type="location"
                user={user}
                userData={userData}
              />
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("username").label}
              value={userData?.username}
              onClick={() => onClickHandler("username")}
            />
            {openInputs.username && (
              <UpdatableInput
                defaultValue={userData?.username}
                onChange={(text) => onChangeHandler(text)}
                onSubmit={() => onSubmitHandler({ username: updatedText })}
                loading={loading}
                inputStrings={findInputStrings("username")}
                type="textField"
                user={user}
                userData={userData}
              />
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("tel").label}
              value={userData?.tel ? `+${userData?.tel}` : ""}
              onClick={() => onClickHandler("tel")}
            />
            {openInputs.tel && (
              <UpdatableInput
                defaultValue={userData?.tel}
                onChange={(text) => onChangeHandler(text)}
                onSubmit={() => onSubmitHandler({ tel: updatedText })}
                loading={loading}
                inputStrings={findInputStrings("tel")}
                type="textField"
                user={user}
                userData={userData}
              />
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("contactEmail").label}
              value={hideEmail(userData?.contactEmail)}
              onClick={() => onClickHandler("contactEmail")}
            />
            {openInputs.contactEmail && (
              <UpdatableInput
                defaultValue={userData?.contactEmail}
                onChange={(text) => onChangeHandler(text)}
                onSubmit={() => onSubmitHandler({ contactEmail: updatedText })}
                loading={loading}
                inputStrings={findInputStrings("contactEmail")}
                type="textField"
                user={user}
                userData={userData}
              />
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={profilePage.certification}
              value={"A1-A3"}
              onClick={() => onClickHandler("certificate")}
            />
            {openInputs.certificate && (
              <Box className="flex">
                <FileUpload
                  setFile={setUserCertificate}
                  title={profilePage.certification}
                  initial={
                    userData?.userCertificate ? userData.userCertificate : null
                  }
                  fileLimit="Max. 2MB"
                  onChange={setCertificateUploaded}
                  type="certification"
                />
                {certificateUploaded && existing && (
                  <FormControl
                    sx={{
                      mt: 3,
                      width: "100%",
                      maxWidth: 600,
                      display: "grid",
                      justifyContent: "center",
                    }}
                    component="form"
                    onSubmit={handleSubmit(handleFormSubmit)}
                  >
                    <LoadingMuiButton
                      loading={loading}
                      text={uiGeneral?.saveButton}
                    />
                  </FormControl>
                )}
              </Box>
            )}

            {/* <div className="certification-input">
              <MuiInput
                label="Certification"
                inputStrings={findInputStrings("displayName")}
                errors={errors}
                register={register}
                onChange={() => {}}
              />
              <FileUpload
                image={getUrl(profImage)}
                setImage={setProfImage}
                initial={userData?.profImage}
                title="Add profile picture"
                imgLimit="Max. 50 kb 150x150px"
                onSubmit={handleFormSubmit}
                type="certification"
              />
            </div> */}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("freeDist").label}
              value={userData?.freeDist ? `${userData?.freeDist} km` : ""}
              onClick={() => onClickHandler("freeTravelDist")}
            />
            {openInputs.freeTravelDist && (
              <UpdatableInput
                defaultValue={userData?.freeDist}
                onChange={(text) => onChangeHandler(text)}
                onSubmit={() => onSubmitHandler({ freeDist: updatedText })}
                loading={loading}
                inputStrings={findInputStrings("freeDist")}
                type="textField"
                user={user}
                userData={userData}
              />
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("maxRange").label}
              value={userData?.maxRange ? `${userData?.maxRange} km` : ""}
              onClick={() => onClickHandler("maxTravelDist")}
            />
            {openInputs.maxTravelDist && (
              <UpdatableInput
                defaultValue={userData?.maxRange}
                onChange={(text) => onChangeHandler(text)}
                onSubmit={() => onSubmitHandler({ maxRange: updatedText })}
                loading={loading}
                inputStrings={findInputStrings("maxRange")}
                type="textField"
                user={user}
                userData={userData}
              />
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("skills").label}
              value={userData?.skills}
              onClick={() => onClickHandler("skills")}
              multiValues={true}
            />

            {openInputs.skills && (
              <UpdatableInput
                onSubmit={handleFormSubmit}
                loading={loading}
                inputStrings={findInputStrings("skills")}
                existing={existing}
                actDroner={actDroner}
                type="skills"
              />

              // <FormControl
              //   sx={{
              //     gap: 2,
              //     width: "100%",
              //     maxWidth: 600,
              //     width: 600,
              //     margin: "0 auto",
              //   }}
              //   component="form"
              //   onSubmit={handleSubmit(handleFormSubmit)}
              // >
              //   <Box
              //     sx={{
              //       width: "100%",
              //       display: "grid",
              //       gridTemplateColumns: "1fr max-content",
              //       alignItems: "center",
              //       gap: "16px",
              //     }}
              //   >
              //     <Controller
              //       rules={{
              //         required: findInputStrings("skills").requiredErrorMessage,
              //       }}
              //       render={({ field: { onChange }, fieldState }) => (
              //         <Autocomplete
              //           multiple={
              //             existing && actDroner?.subscriptionLevel !== "free"
              //           }
              //           defaultValue={userData?.skills}
              //           options={dcContent.skills.map((skill) => skill.name)}
              //           renderInput={(params) => (
              //             <TextField
              //               error={!!fieldState.error}
              //               helperText={fieldState.error?.message}
              //               {...params}
              //               variant="outlined"
              //             />
              //           )}
              //           onChange={(e, data) =>
              //             onChange(Array.isArray(data) ? data : [data])
              //           }
              //         />
              //       )}
              //       onChange={([, data]) => data}
              //       defaultValue={userData?.skills}
              //       name={findInputStrings("skills").id}
              //       control={control}
              //     />

              //     <LoadingMuiButton
              //       loading={loading}
              //       text={uiGeneral?.saveButton}
              //     />
              //   </Box>
              //   {actDroner?.subscriptionLevel !== "enterprise" && (
              //     <Box sx={{ width: "auto" }}>
              //       <FeatureBadge text=" unlimited skills" level="enterprise" />
              //     </Box>
              //   )}
              // </FormControl>
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("equipment").label}
              value={userData?.equipment}
              multiValues={true}
              onClick={() => onClickHandler("equipment")}
            />

            {openInputs.equipment && (
              <UpdatableInput
                onSubmit={handleFormSubmit}
                loading={loading}
                inputStrings={findInputStrings("equipment")}
                allEquipment={allEquipment}
                type="equipment"
                user={user}
                userData={userData}
              />
            )}

            {/* /////////////////////////////////////////////////// */}
            <InputCover
              label={getFormField("bio").label}
              value={userData?.bio}
              onClick={() => onClickHandler("bio")}
            />
            {openInputs.bio && (
              <UpdatableInput
                defaultValue={userData?.bio}
                onChange={(text) => onChangeHandler(text)}
                onSubmit={() => onSubmitHandler({ bio: updatedText })}
                loading={loading}
                inputStrings={findInputStrings("bio")}
                type="textField"
                user={user}
                userData={userData}
              />
            )}
          </div>
        )}
      </Box>
    </Box>
  );
}

{
  /* {0 > 1 && (
          <>
            <FormControl
              sx={{ gap: 2, width: 600, margin: "0 auto" }}
              component="form"
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              {formFields.map((det, i) => {
                const fieldsFromDcCont = dcContent.forms.registerDetails.filter(
                  (s) => s.id === det.fieldId
                )[0];
                const formStrings = {
                  ...det,
                  ...fieldsFromDcCont,
                };


                switch (formStrings.formType) {
                  case "textField":
                    return (
                      <>
                        <Box
                          key={i}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <TextField
                            sx={{ flexGrow: 1 }}
                            multiline={formStrings.multiline}
                            type={formStrings.type}
                            id={formStrings.id}
                            label={formStrings.label}
                            helperText={errors[formStrings.id]?.message}
                            error={!!errors[formStrings.id]}
                            {...register(formStrings.id, {
                              required: {
                                value: formStrings.required,
                                message: formStrings.requiredErrorMessage,
                              },
                              min: {
                                value: formStrings.minValue,
                                message: formStrings.rangeErrorMessage,
                              },
                              max: {
                                value: formStrings.maxValue,
                                message: formStrings.rangeErrorMessage,
                              },
                              maxLength: {
                                value: formStrings.maxLength,
                                message: formStrings.maxLengthMessage,
                              },
                              minLength: {
                                value: formStrings.minLength,
                                message: formStrings.minLengthMessage,
                              },
                              pattern: {
                                value: formStrings.pattern,
                                message: formStrings.patternMessage,
                              },
                            })}
                          />
                          <Tooltip
                            title={formStrings.tooltip}
                            disableHoverListener={!formStrings.tooltip}
                            disableFocusListener={!formStrings.tooltip}
                            disableTouchListener={!formStrings.tooltip}
                            sx={{
                              color: formStrings.tooltip
                                ? "auto"
                                : "transparent",
                            }}
                          >
                            <InfoOutlinedIcon
                              fontSize="small"
                              sx={{ color: theme.palette.textColors.main }}
                            />
                          </Tooltip>
                        </Box>
                        {formStrings.id === "username" && (
                          <p className="ml-normal text-text-lighten1">
                            dronecakes.com/droners/<b>{formStrings.label}</b>
                          </p>
                        )}
                      </>
                    );

                  case "places":
                    return (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            flexGrow: 1,
                            maxWidth: "100%",
                          }}
                        >
                          <Controller
                            rules={{
                              required: formStrings.required,
                            }}
                            render={({ field, fieldState }) => (
                              <>
                                <GooglePlacesAutocomplete
                                  apiKey={process.env.NEXT_PUBLIC_MAPS_API_KEY}
                                  selectProps={{
                                    placeholder: formStrings?.label,
                                    // defaultInputValue: userData?.address,
                                    ...field,
                                    theme: googleMapsInput.theme,
                                    styles: googleMapsInput.styles,
                                  }}
                                />
                                {fieldState.error && (
                                  <div style={{ color: "red" }}>
                                    {formStrings.requiredErrorMessage}
                                  </div>
                                )}
                              </>
                            )}
                            // onChange={([, data]) => data}
                            name={formStrings.id}
                            control={control}
                          />
                        </Box>
                        {!!formStrings.tooltip && (
                          <Tooltip title={formStrings.tooltip}>
                            <InfoOutlinedIcon fontSize="small" />
                          </Tooltip>
                        )}
                      </Box>
                    );

                  case "select":
                    return (
                      <Fragment key={i}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ flexGrow: 1, maxWidth: "100%" }}>
                            <Controller
                              rules={{
                                required: formStrings.requiredErrorMessage,
                              }}
                              render={({ field: { onChange }, fieldState }) => (
                                <Autocomplete
                                  multiple={
                                    existing &&
                                    actDroner?.subscriptionLevel !== "free"
                                  }
                                  defaultValue={userData?.skills}
                                  options={dcContent.skills.map(
                                    (skill) => skill.name
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      error={!!fieldState.error}
                                      helperText={fieldState.error?.message}
                                      {...params}
                                      label={formStrings.label}
                                      variant="outlined"
                                    />
                                  )}
                                  onChange={(e, data) =>
                                    onChange(
                                      Array.isArray(data) ? data : [data]
                                    )
                                  }
                                />
                              )}
                              onChange={([, data]) => data}
                              // defaultValue={userData?.skills}
                              name={formStrings.id}
                              control={control}
                            />
                          </Box>
                          <Tooltip title={formStrings.tooltip}>
                            <InfoOutlinedIcon fontSize="small" />
                          </Tooltip>
                        </Box>
                        {actDroner?.subscriptionLevel !== "enterprise" && (
                          <Box sx={{ width: "auto" }}>
                            <FeatureBadge
                              text=" unlimited skills"
                              level="enterprise"
                            />
                          </Box>
                        )}
                      </Fragment>
                    );

                  case "equipment":
                    return (
                      <Box
                        key={i}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Box sx={{ flexGrow: 1, maxWidth: "100%" }}>
                          <Controller
                            render={({ field: { onChange } }) => (
                              <Autocomplete
                                freeSolo
                                autoSelect
                                multiple
                                defaultValue={userData?.equipment}
                                options={allEquipment.map((eq, i) => eq.name)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={formStrings.label}
                                    variant="outlined"
                                  />
                                )}
                                onChange={(e, data) => onChange(data)}
                              />
                            )}
                            onChange={([, data]) => data}
                            defaultValue={userData?.equipment}
                            name={formStrings.id}
                            control={control}
                          />
                        </Box>
                        <Tooltip title={formStrings.tooltip}>
                          <InfoOutlinedIcon fontSize="small" />
                        </Tooltip>
                      </Box>
                    );
                }
              })}

              <Box
                sx={{ display: "flex", justifyContent: "center", gap: 2 }}
                mt={4}
              >
                <LoadingButton
                  variant="contained"
                  sx={{
                    backgroundColor: theme.palette.primary.light,
                    width: "100%",
                  }}
                  loading={loading}
                  type="submit"
                >
                  {uiGeneral?.saveButton}
                </LoadingButton>
              </Box>
            </FormControl>
          </>
        )} */
}
